class AnnouncementBarSection {
  constructor() {
    this.announcementBar = document.querySelector('.announcement-bar-section');
    this.isScrolled = false;
    this.scrollThreshold = 10; // pixels to scroll before switching to fixed
    
    if (this.announcementBar) {
      this.init();
    }
  }

  init() {
    // Set initial height CSS variable
    this.updateHeight();
    
    // Add scroll event listener
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // Handle resize events to update height
    window.addEventListener('resize', this.updateHeight.bind(this));
    
    // Initial check
    this.handleScroll();
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > this.scrollThreshold && !this.isScrolled) {
      this.setScrolled(true);
    } else if (scrollTop <= this.scrollThreshold && this.isScrolled) {
      this.setScrolled(false);
    }
  }

  setScrolled(scrolled) {
    this.isScrolled = scrolled;
    
    if (scrolled) {
      this.announcementBar.classList.add('scrolled');
      document.body.classList.add('has-fixed-announcement');
    } else {
      this.announcementBar.classList.remove('scrolled');
      document.body.classList.remove('has-fixed-announcement');
    }
  }

  updateHeight() {
    if (this.announcementBar) {
      const height = this.announcementBar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-height', `${height}px`);
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new AnnouncementBarSection();
});

// Also initialize immediately if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AnnouncementBarSection();
  });
} else {
  new AnnouncementBarSection();
} 

